import { Box } from '@mui/material';
import { useState } from 'react';
import { Tooltip } from 'src/components';
import { DispatchStatusGrid, DispatchStatusGridProps } from './dispatch-status-grid';
import { DispatchStatusIcon } from './dispatch-status-icon';

interface MessageDispatchStatusProps {
  dispatches: DispatchStatusGridProps['dispatches'];
  from: DispatchStatusGridProps['from'];
  to?: DispatchStatusGridProps['to'];
}

export const DispatchStatusTooltip = ({
  dispatches,
  from,
  to,
}: MessageDispatchStatusProps) => {
  const [open, setOpen] = useState(false);

  const handleToggle = () => setOpen((prev) => !prev);
  const handleClose = () => setOpen(false);
  const handleOpen = () => setOpen(true);

  return (
    <Tooltip
      open={open}
      onOpen={handleOpen}
      onClose={handleClose}
      componentsProps={{
        tooltip: { sx: { padding: 0 } },
      }}
      nonInteractable={false}
      enterDelay={300}
      leaveDelay={400}
      placement="top"
      arrow
      title={<DispatchStatusGrid from={from} to={to} dispatches={dispatches} />}
    >
      <Box onClick={handleToggle} sx={{ cursor: 'pointer' }}>
        <DispatchStatusIcon dispatches={dispatches} />
      </Box>
    </Tooltip>
  );
};
